export default function StatusBar({ label, value, max, className, known = true, stale = false }) {
  const normalizedMax = Math.max(1, Number(max) || 100);
  const normalizedValue = Math.max(0, Math.min(normalizedMax, Number(value) || 0));
  const percentage = Math.round((normalizedValue / normalizedMax) * 100);
  const suffix = stale && known ? ' (last known)' : '';

  return (
    <div
      className={`play2-vital-bar ${className || ''}${known ? '' : ' play2-vital-bar-unknown'}`}
      aria-label={`${label}: ${known ? `${normalizedValue} of ${normalizedMax}` : 'Unknown'}${suffix}`}
      title={`${label}: ${known ? `${normalizedValue}/${normalizedMax}` : 'Unknown'}${suffix}`}
    >
      {known && <span style={{ height: `${percentage}%` }} />}
    </div>
  );
}
